import React from 'react';

export const GermanFlag = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="16" fill="#000000" />
    <rect y="5.33" width="24" height="5.33" fill="#DD0000" />
    <rect y="10.67" width="24" height="5.33" fill="#FFCE00" />
  </svg>
);

export const USFlag = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="16" fill="#B22234" />
    <rect y="1.23" width="24" height="1.23" fill="white" />
    <rect y="3.69" width="24" height="1.23" fill="white" />
    <rect y="6.15" width="24" height="1.23" fill="white" />
    <rect y="8.62" width="24" height="1.23" fill="white" />
    <rect y="11.08" width="24" height="1.23" fill="white" />
    <rect y="13.54" width="24" height="1.23" fill="white" />
    <rect width="9.6" height="8.62" fill="#3C3B6E" />
  </svg>
);